import { useEffect, useRef, useState } from "react";
import { socket } from "../socket/socketClient";

export default function useMeetingStatus(meetingId) {
	const [isActive, setIsActive] = useState(false);
	const [userCount, setUserCount] = useState(0);
	const lastMeetingIDRef = useRef(null);

	useEffect(() => {
		if (!meetingId) return;

		const handleStatusResponse = ({ meetingId: id, active, users }) => {
			if (id === meetingId) {
				setIsActive(active);
				setUserCount(users);
				// console.log(
				// 	`📡 Estado actualizado para ${id}: ${active} (${users} usuarios)`
				// );
			}
		};

		// Suscribirse a las actualizaciones de estado
		socket.on("meeting_status_response", handleStatusResponse);

		// Solicitar estado inicial
		if (meetingId !== lastMeetingIDRef.current) {
			lastMeetingIDRef.current = meetingId;
			socket.emit("request_meeting_status", meetingId);
			// console.log(`🔍 Solicitando estado inicial para meeting: ${meetingId}`);
		}

		return () => {
			socket.off("meeting_status_response", handleStatusResponse);
		};
	}, [meetingId]);

	return { isActive, userCount };
}
